<script setup>
  import {
    onMounted,
    ref,
  } from 'vue'

  import SideBanners from '@components/SideBanners.vue'
  import SideBlog from '@components/SideBlog.vue'
  import SideInquiry from '@components/SideInquiry.vue'

  import { useAjax } from '@composables/useAjax.js'
  import { useI18n } from '@shared/i18n.js'

  const props = defineProps({
    agentMemberId: String,
    agentPath: String,
    banners: {
      default: true,
      type: Boolean,
    },
    blog: {
      default: true,
      type: Boolean,
    },
    blogClassList: {
      default: 'blog_list',
      type: String
    },
  })

  const agent = ref(null)

  const { callGet } = useAjax()
  const { t } = useI18n()

  onMounted(() => {
    getAgent()
  })

  const getAgent = async () => {
    if (!props.agentPath) return

    const response = await callGet(props.agentPath)

    if (response.agent) {
      agent.value = response.agent
    }
  }
</script>

<template>
  <SideInquiry
    v-if="agent"
    :agent="agent"
    :agent-member-id="agentMemberId"
    :show-agent-name="true"
    :title="t('enquiries.show.js.contact_agent')"
  />
  <SideBanners v-if="banners" suffix="u" />
  <SideBlog v-if="blog" :class-list='blogClassList' />
</template>
